angular
  .module('countriesApp')
  .service('CompanyModel', [
    'RoutesService',
    function(Routes) {
      return class CompanyModel {
        constructor(data) {
          this.logo_url = data.logo_url;
          this.name = data.name;
          this.slug_and_id = data.slug_and_id;

          this.link = Routes.organization_path({ slug_and_id: this.slug_and_id });
        }
      };
    }
  ]);
